import { Search } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import CreateModal from "./CreateModal";
import { useUserInfo } from "../../../context/user";
import { useUsersContext } from "../../../context/usersContext";
import { LinearProgress, linearProgressClasses, styled } from "@mui/material";
import localforage from "localforage";
import Icon from "../../../components/icons";
import AddUserModal from "../../Settings/components/team/component/AddUserModal";
import { useNavigate } from "react-router-dom";
import { useAppServices } from "../../../hook/services";
import AddSharpIcon from '@mui/icons-material/AddSharp';

const SideBar = ({
  filteredAgents,
  searchQuery,
  setSearchQuery,
  handleRefresh,
  numberOfAgents,
  companyInfo,
  setCategoryFilter,
  categoryFilter,
  setActiveOnly,
  activeOnly,
}) => {
  // No need to filter the agents here as they are already filtered
  // in the parent component before being passe
  //d to SideBar
  const accountPlugins = useUserInfo()[19];
  const { products, locationUsers, setIsAuto, setUseAgent } = useUsersContext();
  const activeProduct = products?.filter((item) => item.activePlan)?.[0];
  const [openTeamModal, setOpenTeamModal] = useState(false);
  const userActiveLocation = useUserInfo()[4];
  const navigate = useNavigate();
  const service = useAppServices()

  const [agency, setAgency] = useState(null);

  useEffect(() => {
    const loadAgency = async () => {
      const result = await service.agency.getAgency({
        query: `_id=${userActiveLocation?.agency_id}`,
      });
      if (result?.response?.data) setAgency(result.response.data);
    };
    if (userActiveLocation?.agency_id)
      loadAgency();
  }, []);

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 10,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "#f5f5f5",
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 10,
      backgroundColor: "#1e1e1e",
    },
  }));

  return (
    <div className="h-full px-4 pt-[26px]">
      <CreateModal
        open={false}
        onClose={() => alert("Modal closed")}
        numberOfAgents={numberOfAgents}
        pluginsdata={accountPlugins}
        handleRefresh={handleRefresh}
        activeProduct={activeProduct}
        products={products}
      />

      {/* <button onClick={() => {
        setIsAuto(true);
        setUseAgent(true);
        setSelectedAssistantId(null);
        setTimeout(() => { navigate("/app/chatapp"); }, 1000);
      }}
        className="flex items-center space-x-2 p-2 text-sm justify-center w-full border border-black text-black rounded-lg cursor-pointer mt-6">
        <AddSharpIcon fontSize="15" />

        <span>Use All Agents</span>
      </button> */}

      <div className="relative mt-[22px]">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="font-[12px] py-[15px] !px-4 text-[12px] !rounded-full "
          placeholder="Search AI Agents"
        />
        <Search
          fontSize="small"
          className="absolute top-[12px] right-[16px] text-black"
        />
      </div>

      <div className="w-full flex flex-col justify-between mt-[22px]">
        <span
          onClick={() => {
            setCategoryFilter("");
            !activeOnly && filteredAgents.length === 0 && setActiveOnly(true);
          }}
          className="text-[12px] cursor-pointer font-medium bg-[#F0F0F0] py-[10px] px-[18px] rounded-[5px]"
        >
          All AI Agents
        </span>

        <span
          onClick={() => {
            setCategoryFilter("Your AI Agents");
          }}
          className={`flex items-center hover:bg-[#F0F0F0] text-xs cursor-pointer justify-between mt-[10px] py-[5px] px-[18px] rounded-[5px] transition-all duration-200 ${categoryFilter === "Your AI Agents"
            ? "bg-[#F0F0F0]"
            : "hover:bg-[#F0F0F0]"
            }`}
        >
          Your AI Agents
        </span>

        {agency?.Categories?.map((category, index) => (
          <div
            key={index}
            onClick={() => {
              setCategoryFilter(
                categoryFilter === category.id ? "" : category.id
              );
            }}
            className={`flex items-center hover:bg-[#F0F0F0] cursor-pointer justify-between mt-[10px] py-[5px] px-[18px] rounded-[5px] transition-all duration-200 ${categoryFilter === category.id
              ? "bg-[#F0F0F0]"
              : "hover:bg-[#F0F0F0]"
              }`}
          >
            <span className={`text-[12px] font-medium ${"text-[#757575]"}`}>
              {category?.name}
            </span>
          </div>
        ))}
      </div>
      {/* <div className="absolute  -bottom-3 left-0 bg-white h-[67px] border !border-[#d9d9d9] rounded w-full py-4 px-[14px]">
        <p className="text-xs font-medium flex justify-between items-center mb-2.5 font-inter">
          <span>AI Agent Usage</span>
          <span>
            {numberOfAgents}/{activeProduct?.agenct_config?.agent_limit || 0}
          </span>
        </p>
        <BorderLinearProgress
          variant="determinate"
          value={
            (numberOfAgents / activeProduct?.agenct_config?.agent_limit || 0) *
            100
          }
        />
      </div> */}
      <div
        style={{
          width: "100%",
          position: "absolute",
          bottom: 0,
          right: 0,
          left: 0,
          background: "#fff",
        }}
      >
        <div
          className="border border-black px-1 py-3 mx-4 mb-4 text-center cursor-pointer"
          onClick={() => navigate("/app/settings", { state: { tab: "Team" } })}
        >
          <span>
            <Icon id={"AddTeamMember"} />
            <span className="text-[15px] ml-2">Invite Team Members</span>
          </span>
        </div>
      </div>
      {openTeamModal && (
        <AddUserModal
          isModalOpen={openTeamModal}
          justCloseIt={() => setOpenTeamModal(false)}
          userActiveLocation={userActiveLocation}
          activeplans={activeProduct}
          locationUsers={locationUsers}
          setActiveTab={() =>
            navigate("/app/settings", { state: { tab: "Pricing" } })
          }
        />
      )}
    </div>
  );
};

export default SideBar;
